<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="140px">
            <el-row :gutter="50">
                <el-col :span="12">
                    <el-form-item label="标题" prop="title">
                        <el-input v-model="form.title" placeholder="请输入标题"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="标题（英文）" prop="enTitle">
                        <el-input v-model="form.enTitle" placeholder="请输入标题（英文）"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="副标题" prop="subTitle">
                        <el-input v-model="form.subTitle" placeholder="请输入副标题"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="副标题（英文）" prop="enSubTitle">
                        <el-input v-model="form.enSubTitle" placeholder="请输入副标题"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="正文" prop="content">
                        <el-input type="textarea" :rows="6" v-model="form.content"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="正文（英文）" prop="enContent">
                        <el-input type="textarea" :rows="6" v-model="form.enContent"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="推送平台">
                <el-radio-group v-model="form.pushPlatform">
                    <el-radio :label="1">极光推送</el-radio>
                    <el-radio :label="2">站内消息</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button @click="$router.back()">取消</el-button>
                <el-button type="primary" @click="handleSave">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { add } from "@/api/message/list";
import Editor from "@/components/Editor";
export default {
    components: { Editor },
    data() {
        return {
            id: null,
            form: {
                title: "",
                subTitle: "",
                content: "",
                enTitle: "",
                enSubTitle: "",
                enContent: "",
                pushPlatform: ""
            },
            rules: {
                title: [{ required: true, message: '请输入标题' }],
                subTitle: [{ required: true, message: '请输入副标题' }],
                content: [{ required: true, message: '请输入正文' }],
                enTitle: [{ required: true, message: '请输入标题（英文）' }],
                enSubTitle: [{ required: true, message: '请输入副标题（英文）' }],
                enContent: [{ required: true, message: '请输入正文（英文）' }]
            }
        }
    },
    methods: {
        handleSave() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                const params = {
                    ...this.form
                }
                add(params).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success("添加成功");
                        this.$router.back();
                    } else {
                        this.$message.error(message);
                    }
                })
            })
        }
    }
}
</script>

<style></style>